<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                应用选择
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                应用选择
            </div>
        </div>
        <div>
            <el-form :model="ecxForm" :rules="actrules" ref="ecxForm"
                     label-width="150px" class="demo-ruleForm">
                <el-form-item label="应用类型" prop="appType">
                    <el-select v-model="ecxForm.app_type_id" :disabled="disabled"
                               placeholder="应用类型" style="width: 35%;"
                               @change="chacngeAppType()">
                        <el-option v-for="item in appTypeList" :value="item.app_type_id"
                                   :label="item.app_type_name" :key="item.app_type_id"
                        ></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item style="margin-left: -150px">
                    <component :actId="actID" :actStatus="status" :actStatus2="act_status"
                               v-bind:is="which_to_show" keep-alive
                               @listenToChildEventDef="sendMsgToParent"></component>
                </el-form-item>
                <!--上一步按钮 下一步按钮-->
                <el-form-item style="margin-top: 10%;margin-left: 16.5%;" v-show="isVisible">
                    <el-button type="primary" @click="lastStep('ecxForm')"
                               id="last_step">上一步
                    </el-button>
                    <el-button type="primary" @click="cancelApp()"
                               id="cancel">取消
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog title="推广活动" :visible.sync="dialogFormVisible"
                   :modal-append-to-body="false" style="height: 150%">
            <div style="text-align: center;font-size: 40px;margin-top: -20px">活动创建成功</div>
            <div style="margin-top: 10px;">
                <el-input id="input" placeholder="搜索活动" style="width: 90%" v-model="URL" readonly></el-input>
                <el-button type="primary" class="copy" @click="copyData">
                    复制
                </el-button>
            </div>
            <div style="margin-top: 20px">
                <el-button size="small" type="text" @click="createCode()">
                    点击生成二维码
                </el-button>
            </div>
            <div style="text-align: center">
                <canvas id="msg"></canvas>

                <!--<qrcode-vue :value='111111111111111111' :size='200'
                            className='qrcode' id="picture" ref="code"></qrcode-vue>-->
            </div>
            <div style="margin-top: 20px;text-align: center">
                <el-button size="small" type="text" @click="cancelApp()">
                    返回活动列表
                </el-button>
                <el-button size="small" type="text" @click="loadCode()">
                    下载二维码
                </el-button>
                <el-button size="small" type="text" @click="newCreate()">
                    创建下一个活动
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // 引入qrcode
    import QRCode from 'qrcode'
    /*派样配置*/
    import SamplingFragment from "~/components/views/activity/SamplingFragment";
    /*转盘配置*/
    import WheelFragment from "~/components/views/activity/WheelFragment";
    //每日特价
    import SeckillApp from "~/components/views/activity/SeckillApp";
    //满减活动
    import FullSubtractApp from "~/components/views/activity/FullSubtractApp";
    import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";


    export default {
        name: "CheckApp",
        components: {
            ElOption,
            SamplingFragment,
            SeckillApp,
            FullSubtractApp,
            WheelFragment,
        },
        /*活动ID，按钮状态(0.创建；1.编辑；2.查看)，活动状态*/
        props: ["actID", "status","act_status"],

        data() {
            return {
                isLastStep: false,
                isNextStep: false,
                isVisible:true,
                findAppTypeHost: this.admin_host + "/admin/activity/app/type/find/list",
                prodindex: 0,
                appTypeList: [],
                ecxForm: {
                    app_type_id: ' ',
                },
                actId: '',//活动ID
                isEditer: false,//是否编辑状态
                appType: '',//应用类型
                samplingFragment: "",
                actrules: {
                    appType: [
                        {required: true, message: '请选择应用', trigger: 'blur'},
                    ],

                },
                which_to_show: "",
                disabled:false,
                /*弹窗选择*/
                dialogFormVisible: false,
                URL: '',
                message:'', //复制消息
            }
        },
        created() {
            this.findAppType();
            this.chacngeAppType()
            this.getAppType();
        },
        methods: {
            /*查询应用类型--没有参数*/
            findAppType: function () {
                this.$http.get(this.findAppTypeHost)
                    .then(response => {
                        if (response.body.Code === "200") {
                            console.log(response.body)
                            this.appTypeList = response.body.Data.appTypeList;
                        } else
                            this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*复制链接*/
            copyData(){
                const input = document.createElement('input')
                document.body.appendChild(input)
                input.setAttribute('value',this.URL)
                input.select()
                if (document.execCommand('copy')) {
                    document.execCommand('copy')
                }
                document.body.removeChild(input)
            },

            /*生成二维码*/
            createCode(){
                var msg= document.getElementById('msg')
                // 将获取到的数据（val）画到msg（canvas）上
                QRCode.toCanvas(msg, this.URL, function (error) {
                    if (error) console.error(error)
                    console.log('success!');
                })

            },
            /*下载二维码*/
            loadCode(){
                //找到canvas标签
                let myCanvas = document/*.getElementById('picture')*/.getElementsByTagName('canvas');
                //创建一个a标签节点
                let a = document.createElement("a")
                //设置a标签的href属性（将canvas变成png图片）
                a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
                var date = new Date().getTime();
                //设置下载文件的名字
                a.download = "qrcode_"+date+".png"
                //点击
                a.click()
                //弹出提示
                this.$message({message:'亲，正在进行下载保存',type:'warning'})
            },
            /*根据类型匹配不同的配置*/
            chacngeAppType: function (row) {
                if (this.ecxForm.app_type_id === 'delivery') {
                    this.which_to_show = "SamplingFragment";
                    this.isVisible = false
                }
                else if (this.ecxForm.app_type_id === 'seckill') {
                    this.which_to_show = "SeckillApp";
                    this.isVisible = false
                }
                else if (this.ecxForm.app_type_id === 'full_reduction') {
                    this.which_to_show = "FullSubtractApp";
                    this.isVisible = false
                }else if (this.ecxForm.app_type_id === 'wheel') {
                    this.which_to_show = "WheelFragment";
                    this.isVisible = false
                }
                else {
                    this.which_to_show = "";
                    this.isVisible = true
                }

            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.URL = "https://antgine.paybay.cn/delivery/exManager/autoAuth?actId=" +id;
                console.log("----"+this.URL)
                if (step != "5") {
                    this.$emit("listenToChildEvent", step, id)
                }else{
                    console.log(step)
                    this.dialogFormVisible = true
                }
            },
            /*下一步*/
            nextStep(formName) {
                this.sendMsgToParent("5",   this.actID)
            },
            /*上一步*/
            lastStep(formName) {
                this.sendMsgToParent("3", this.actID)
            },
            /*根据活动编号查询应用信息*/
            getAppType:function () {
                    var url=this.admin_host+"/admin/activity/app/find/info"
                    this.$http.get(url+"?actId="+this.actID)
                        .then(response => {
                            if (response.body.Code === "200") {
                        if(response.body.Data.appId==""){
                            this.disabled=false;
                        }else{
                            this.ecxForm.app_type_id=response.body.Data.appTypeId;
                            this.chacngeAppType();
                            this.disabled=true;
                        }
                            }else   {this.$message({showClose: true, message: '操作异常', type: 'error' }); }
                        },function(response){ this.$message({ showClose: true, message: '网络异常',type: 'error'}); })

            },
            /*取消按钮*/
            cancelApp(){
                this.$router.push({ path: "ActivityManager"  });
            },
            /*创建下一个活动*/
            newCreate(){
                this.$router.push({
                    path: "ActivityManager",query:{newCreate:true,}
                });
                // this.sendMsgToParent("1", this.actID)
            },
        }

    }
</script>

<style  scoped>



</style>



// WEBPACK FOOTER //
// ChoiceApp.vue?085c3c40